import { NavLink } from 'react-router-dom';
import { ArrowForwardIos } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import styles from './Navigation.module.css';
import flag from './flag.png';
import { BRAND } from 'global';

export default function Navigation({ id, name }: { id: number, name: string }) {
  const { t } = useTranslation();

  if (window.location.pathname === '/') return <></>;

  return (
    <nav className={styles.navigation}>
      <div className={styles.content}>
        <div className={styles.row}>
          <p className={styles.logo}>
            {name || BRAND}
          </p>
          <nav className={styles.navigationLink}>
            <NavLink
              to={`/${id}`}
              className={({ isActive }) => isActive ? `${styles.link} ${styles.active}` : styles.link}
              end
            >
              {t('navigation.investment')}
            </NavLink>
            <ArrowForwardIos className={styles.icon} />
            <NavLink
              to={`/${id}/paiement`}
              className={({ isActive }) => isActive ? `${styles.link} ${styles.active}` : styles.link}
            >
              {t('navigation.payment')}
            </NavLink>
            <ArrowForwardIos className={styles.icon} />
            <NavLink
              to={`/${id}/confirmation`}
              className={({ isActive }) => isActive ? `${styles.link} ${styles.active}` : styles.link}
            >
              {t('navigation.engagement')}
            </NavLink>
          </nav>
        </div>
        <div className={`${styles.row} ${styles.hideDesktop}`}>
          <img
            src={flag}
            alt="Drapeau français"
            className={styles.flag}
          />
          <p>
            <span className={styles.problem}>
              {t('navigation.problem')}
            </span>
            <span className={styles.phone}>
              +33 (0)7 55 50 63 90
            </span>
          </p>
        </div>
      </div>
    </nav>
  )
}
